import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const auth = {
  login: lazyModuleMethod(() => import('./login'), 'default'),
  recover: lazyModuleMethod(() => import('./recover'), 'default'),
  changePassword: lazyModuleMethod(() => import('./changePassword'), 'default'),
  deleteSession: lazyModuleMethod(() => import('./deleteSession'), 'default'),
  fetchSessions: lazyModuleMethod(() => import('./fetchSessions'), 'default'),
}
